import { render, staticRenderFns } from "./componentsB.vue?vue&type=template&id=e6b2d236&scoped=true&"
import script from "./componentsB.vue?vue&type=script&lang=js&"
export * from "./componentsB.vue?vue&type=script&lang=js&"
import style0 from "./componentsB.vue?vue&type=style&index=0&id=e6b2d236&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b2d236",
  null
  
)

export default component.exports